module.exports = __webpack_public_path__ + "static/media/CE2797.8bcf660a.png";